import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowDown, Sparkles } from 'lucide-react';

const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });
  const opacity = useTransform(scrollYProgress, [0, 0.4], [1, 0]);
  const scale = useTransform(scrollYProgress, [0, 0.4], [1, 0.95]);

  return (
    <section id="hero" ref={ref} className="hero">
      <motion.div className="hero-content" style={{ opacity, scale }}>

        {/* Profile Image */}
        <motion.div
          className="hero-avatar"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img
            src={process.env.PUBLIC_URL + '/mypic.png'}
            alt="Kotresh C"
            className="hero-avatar-img"
          />
        </motion.div>

        {/* Status Badge */}
        <motion.div
          className="hero-badge"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <span className="dot" />
          Open to Opportunities
        </motion.div>

        {/* Main Title */}
        <motion.h1
          className="hero-name"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          Hi, I'm{' '}
          <span className="gradient-text">Kotresh C</span>
        </motion.h1>

        {/* Nickname */}
        <motion.p
          className="hero-nickname"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.65 }}
        >
          a.k.a <span style={{ color: 'var(--accent-1)', fontWeight: 700 }}>Veer</span>
        </motion.p>

        {/* Tagline */}
        <motion.p
          className="hero-tagline"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          An aspiring Software Engineer with a passion for crafting
          beautiful, modern web experiences. UG Diploma in CSE graduate,
          next stop — B.Tech.
        </motion.p>

        {/* Buttons */}
        <motion.div
          className="hero-buttons"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <button className="btn btn-primary" onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}>
            <Sparkles size={18} />
            View My Work
          </button>
          <button className="btn btn-outline" onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}>
            Learn More
            <ArrowDown size={18} />
          </button>
        </motion.div>
      </motion.div>

    </section>
  );
};

export default Hero;
